<template>
  <div>
    <el-col style="flex:1;border-right: 1px solid #D7D7D7;padding-right: 30px;" :lg="19" :xs="24" :md="18" :sm="24">
      <template>
        <div class="product-container">
          <div class="product-wrapper">
            <div class="product-wrapper-left">
              <div class="product-item" v-for="(item,index) in r.voucher_list" :key="index">
                <div>
                  <img :src="item.content" style="width:120px;height:120px;object-fit: contain;"/>
                </div>
                <!--<div class="product-detail">-->
                <!--<div class="product-name">-->
                <!--<p>{{ item.name }}</p>-->
                <!--</div>-->
                <!--<p v-for="(d,didx) in item.good_detail_arr" :key="didx">{{ d }}</p>-->
                <!--<p v-if="item.price_detail && JSON.parse(item.price_detail).price" class="product-price">-->
                <!--<label :class="{'danger':JSON.parse(item.price_detail).discounted_price}">{{-->
                <!--JSON.parse(item.price_detail).discounted_price || JSON.parse(item.price_detail).price}}</label>-->
                <!--<del style="color:#B0B4BF" v-if="JSON.parse(item.price_detail).discounted_price">{{-->
                <!--JSON.parse(item.price_detail).price }}-->
                <!--</del>-->
                <!--</p>-->
                <!--</div>-->
                <!--<div style="padding-left:30px;width:20%;">
                  <el-button class="block btn-14" type="info" @click="updateMail(item)">处理邮件</el-button>
                </div>-->
              </div>
            </div>
            <div class="product-wrapper-right">
              <template>
                <p style="color:#888888;margin-bottom:10px;">收款人</p>
                <p> {{r.payee_user}}</p>
              </template>
              <template>
                <div class="margin-top-sm">
                  <p style="color:#888888;margin-bottom:10px;">支付方式</p>
                  <p> {{ r.payment_method_name}}：{{r.payment_account_number}}</p>
                </div>
              </template>
              <template>
                <div class="margin-top-sm">
                  <p style="color:#888888;margin-bottom:10px;">交易单号</p>
                  <p>{{r.transaction_number}}</p>
                </div>
              </template>
              <template v-if="r.settlement_time">
                <div class="margin-top-sm">
                  <p style="color:#888888;margin-bottom:10px;">结算时间:</p>
                  <p>{{r.settlement_time}}</p>
                </div>
              </template>
            </div>
          </div>
        </div>
      </template>
    </el-col>
    <el-col style="padding-left:50px;" :span="5">
      <div>
        <template>
          <div>
            <template v-if="r.handler">
              <p style="color: rgb(136, 136, 136);margin-bottom: 5px;">经手人</p>
              <p>
                {{r.handler}}
              </p>
            </template>
            <template v-if="r.update_time">
              <div class="margin-top-sm">
                <p style="color: rgb(136, 136, 136);margin-bottom: 5px;">修改人</p>
                <p>
                  {{r.update_account_name}}:{{r.update_time}}
                </p>
              </div>

            </template>
            <template>
              <div class="margin-top-sm">
                <p style="color: rgb(136, 136, 136);margin-bottom: 5px;">备注</p>
                <p style="margin-bottom: 10px;">
                  <a class="content_link" target="_blank">{{ r.remark}}</a>
                </p>
              </div>
            </template>
            <template v-if="r.bill_settlement_status==1">
              <el-button  type="info"  class="margin-top-sm" @click="updateSettle(2)">
                结算
              </el-button>
              <el-button type="info" class="margin-top-sm" @click="updateSettle(3)">
                取消
              </el-button>
            </template>

          </div>
        </template>
      </div>
      <div>

      </div>
    </el-col>
  </div>
</template>

<script>
  import Order from '../list/Order'

  let _ = require('lodash')

  export default {
    name: 'OrderList',
    props: ['r', 'index', 'taskDisplay'],
    components: {
      Order: Order
    },
    data() {
      return {
        showForward: false
      }
    },
    async mounted() {

    },
    methods: {
      displayFirstLine(str) {
        return str.split("\<br>")[0]
      },
      async updateSettle(index) {
        this.$emit('updateSettle', index)
      },
    }
  }
</script>

<style lang="scss">
  .content_link {
    color: #303133;
  }

  .product-container {
    padding: 15px 0;
    border-bottom: 1px solid #D7D7D7;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      padding-bottom: 0;
      border-bottom: none;
    }

    &.order {
      display: flex;
      justify-content: space-between;
    }
  }

  .product-wrapper {
    display: flex;
    justify-content: space-between;

    .product-wrapper-left.lika {
      margin-left: 237px;

      &.taskDisplay {
        margin-left: 200px;
      }
    }

    .product-wrapper-right {
      text-align: right;
    }

    &:last-child {
      margin-bottom: 0;
    }

    &.order {
      flex: 1;
      border-right: 1px solid #D7D7D7;
      padding-right: 25px;
      line-height: 1;
    }

    .product-wrapper-right.order p {
      color: #888888;
    }
  }

  .product-item {
    display: flex;
    height: 120px;
    margin-bottom: 30px;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      border-bottom: 0;
      padding-bottom: 0;
      margin-bottom: 0;
    }

    .product-detail {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      position: relative;
      top: -3px;
      margin-left: 20px;

      .product-name {
        font-size: 14px;
        color: #333333;
      }

      .product-price {
        line-height: 32px;
        color: black;

        label {
          font-size: 18px;
        }
      }

      .product-price del {
        font-size: 16px;
      }
    }
  }

  .product-price label.danger {
    font-size: 18px;
    color: #FF4650;
  }

</style>



// WEBPACK FOOTER //
// src/pages/orders/amount_bill/CollapseBody.vue